import { useRef, useCallback, useEffect } from 'react';
import { useArrayIterator } from '@dtvgo/react-utils';

function useSourceSelector(sources, { getProgress }) {
  const [source, next] = useArrayIterator(sources);
  const startOffset = useRef();
  const nextSource = useCallback(() => {
    if (!next())
      return false;
    startOffset.current = getProgress();
    return true;
  }, [getProgress, next, startOffset]);
  useEffect(() => {
    startOffset.current = void 0;
  }, [sources]);
  return { source, nextSource, startOffset: startOffset.current };
}

export { useSourceSelector };
//# sourceMappingURL=useSourceSelector.js.map
